import { AppState } from '../../root-reducer';

export const selectUserProfile = (state: AppState) => state.userProfileDomain.userProfile;

export const selectUserListings = (state: AppState) => state.userProfileDomain.userListings;
